import { use, useEffect, useState } from "react";
import { Menu } from "../../components/menu/menu";
import { bemCN } from "../../config/bem-classname";
import "./profile-page.scss";
import { UserDTO } from "../../api/Api";
import { userService } from "../../services/user-service";
import { Card } from "../../ui/card/card";
import { IconLink } from "../../ui/icon-link/icon-link";

import { ReactComponent as EmailIcon } from "../../shared/images/svg/email.svg";
import { ReactComponent as PasswordIcon } from "../../shared/images/svg/password.svg";
import { ReactComponent as MessageIcon } from "../../shared/images/svg/message_2.svg";
import { ReactComponent as ShieldIcon } from "../../shared/images/svg/shield.svg";
import { ReactComponent as LogoutIcon } from "../../shared/images/svg/logout.svg";

import { links } from "../../config/links";
import { Modal } from "../../ui/modal/modal";
import { authService } from "../../services/auth-service";
import { useNavigate } from "react-router";
import { Button, ButtonColors, ButtonSizes } from "../../ui/button/button";

const profilePageCn = bemCN("profile-page");

export const ProfilePage = () => {
  const [user, setUser] = useState<UserDTO>({ email: "", name: "", planId: 0 });
  const [isShowModal, setIsShowModal] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    userService.getUser().then((res: UserDTO) => {
      setUser(res);
    });
  }, [1]);

  const onClickLogout = () => {
    setIsShowModal(true);
  };

  const logout = () => {
    setIsShowModal(false);
    authService.logout().then((res: number) => navigate(links.start));
  };

  return (
    <div className={profilePageCn()}>
      <Menu title="Профиль" />
      <div className={profilePageCn("user-data")}>
        <div className={profilePageCn("avatar")}></div>
        <div>
          <p>{user.name}</p>
          <p>Юный читатель</p>
        </div>
      </div>

      <Card>
        <div className={profilePageCn("links")}>
          <p className={profilePageCn("title")}>Ваши данные</p>
          <IconLink text="E-mail" icon={<EmailIcon />} link={links.profileInfo} />
          <IconLink text="Пароль" icon={<PasswordIcon />} link={links.profileInfo} />
        </div>
      </Card>

      <Card>
        <div className={profilePageCn("links")}>
          <p className={profilePageCn("title")}>Другое</p>
          <IconLink
            text="Связаться с нами"
            icon={<MessageIcon />}
            link={links.feedback}
          />
          <IconLink
            text="Политика конфиденциальности"
            icon={<ShieldIcon />}
            link={links.policy}
          />
          <IconLink
            text="Правила использования"
            icon={<ShieldIcon />}
            link={links.rules}
          />
          <IconLink
            text="Выйти из аккаунта"
            icon={<LogoutIcon />}
            onClick={onClickLogout}
          />
        </div>
      </Card>

      <Modal id="logoutProfileModal" isShowDialog={isShowModal} setIsShowDialog={setIsShowModal}>
        <div className={profilePageCn("modal")}>
          <p>Вы уверены что хотите выйти из аккаунта?</p>
          <Button
            onClick={logout}
            color={ButtonColors.violet}
            size={ButtonSizes.big}
            text="Выйти из аккаунта"
          />
          <Button
            onClick={() => setIsShowModal(false)}
            color={ButtonColors.green}
            size={ButtonSizes.big}
            text="Назад"
          />
        </div>
      </Modal>
    </div>
  );
};
